import { FleetNavigationModule } from "@app/main/modules/fleet/fleet.navigation";
import * as angular from "angular";
import * as moment from "moment";
import { IVeriTableHeader, IVeriTableRow, IVeriTableRowCell } from "../../../../directives/_veri/veriTable/veriTable.component";
import { VeriTableService } from "../../../../directives/_veri/veriTable/veriTable.service";
import { IDriver } from "../../../../interfaces/IDriver";
import { IJourney } from "../../../../interfaces/IJourney";
import { IVehicle } from "../../../../interfaces/IVehicle";
import { DriverService } from "../../../../services/driver.service";
import { JourneyService } from "../../../../services/journey.service";
import { NavigationService } from "../../../../services/navigation.service";
import { VehicleService } from "../../../../services/vehicle.service";
import "./driverView.component.scss";

class Controller implements angular.IComponentController {
    private driver: IDriver;

    loading = false;

    driverId: number;

    journeys: IJourney[];
    vehicles: IVehicle[];

    tableHeaders: IVeriTableHeader[] = [];
    tableRows: IVeriTableRow<IDriver>[] = [];

    static $inject = ["$q", "driverService", "vehicleService", "veriTableService", "navigationService", "journeyService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly driverService: DriverService,
        private readonly vehicleService: VehicleService,
        private readonly veriTableService: VeriTableService,
        private readonly navigationService: NavigationService,
        private readonly journeyService: JourneyService) {
    }

    $onInit(): void {
        this.createTableHeaders();
        this.getData();
    }

    close() {
        this.navigationService.go(FleetNavigationModule.Drivers);
    }

    // ---

    private getData() {
        this.loading = true;

        // Get historical day
        var start = moment().add(-1, "d");
        var end = moment();

        const driverPromise = this.driverService.getDriver(this.driverId);
                const journeyPromise = this.journeyService.getJourneysForDriverSlim(this.driverId, start, end);
        const vehiclePromise = this.vehicleService.getVehicles({ includePeripheralMappings: true });

        this.$q.all([driverPromise, journeyPromise, vehiclePromise])
            .then(([driver, journeys, vehicles]) => {
                this.driver = driver;
                this.journeys = journeys;
                this.vehicles = vehicles;

                console.log(journeys);

                this.createTableRows();
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private createTableHeaders() {
        this.tableHeaders = [
            this.veriTableService.createVehicleRegHeader(),
            this.veriTableService.createDateTimeHeader("Start Time"),
            { title: "Start Location", sortable: true, },
            this.veriTableService.createDateTimeHeader("End Time"),
            { title: "End Location", sortable: true, },
        ];
    }

    private createTableRows(): void {
        this.tableRows = this.veriTableService.createTableRowsWithCells(this.journeys, data => this.createTableRowCells(data));
    }

    private createTableRowCells(journey: IJourney): IVeriTableRowCell[] {
        const vehicle = this.vehicles.find(v => v.Id == journey.VehicleId);

        return [
            this.veriTableService.createVehicleRegCell(vehicle),
            this.veriTableService.createDateTimeCell(journey.StartUtc),
            this.veriTableService.createLocationInformationCell(journey.StartPlotId, "row.data", { Id: journey.StartPlotId}),
            this.veriTableService.createDateTimeCell(journey.EndUtc),
            this.veriTableService.createLocationInformationCell(journey.EndPlotId, "row.data", { Id: journey.EndPlotId })
        ];
    }
}

export class DriverViewComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            driverId: "<"
        };

        this.controller = Controller;
        this.template = require("./driverView.component.html");
    }
}
